<template>
  <b-modal
    id="usuariosCliente"
    no-close-on-backdrop
    no-close-on-esc
    centered
    hide-footer
    size="lg"
    :title="'Usuários ' + clienteDados.cliente"
  >
  <b-card no-body>
    <h6 class="m-1 text-success">
      <feather-icon icon="UserCheckIcon" size="15"/>
     <span style="padding-left: 5px; padding-top: 5px">Usuários Ativos</span>
    </h6>
    <b-table
      striped
      hover
      small
      responsive
      :items="usuariosAtivos"
      :fields="fields"
    >
      <template #cell(mfa)="data">
        <b-button
          v-if="data.item.mfa"
          size="sm"
          variant="outline-danger"
          @click="resetarMfa(data.item)"
        >
          Resetar Mfa
        </b-button>
        <span v-else>-</span>
      </template>
    </b-table>
    </b-card>
    <b-card no-body>
      <h6 class="m-1 text-danger">
      <feather-icon icon="UserXIcon" size="15"/>
     <span style="padding-left: 5px; padding-top: 5px">Usuários Excluídos</span>
    </h6>
    <b-table
      striped
      hover
      small
      responsive
      :items="usuariosExcluidos"
      :fields="fields"
    >
      <template #cell(mfa)="data">
        <b-button
          v-if="data.item.mfa"
          size="sm"
          variant="outline-danger"
          @click="resetarMfa(data.item)"
        >
          Resetar Mfa
        </b-button>
        <span v-else>-</span>
      </template>
    </b-table>
    </b-card>
  </b-modal>
</template>

<script>
import { BModal, BCard, BTable, BButton } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  props: ["clienteDados", "usuariosCliente"],
  components: {
    BModal,
    BCard,
    BTable,
    BButton,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Nome" },
        { key: "email", label: "E-mail" },
        { key: "mfa", label: "MFA" },
      ],
    }
  },
  computed: {
    usuariosAtivos() {
      return (this.usuariosCliente || []).filter(el => !el.deleted_at);
    },
    usuariosExcluidos() {
      return (this.usuariosCliente || []).filter(el => !!el.deleted_at);
    }
  },
  methods: {
    resetarMfa(item) {
      this.$http
        .put(`adm/administracao/usuarios-cliente/resetar-mfa/${item.id}`)
        .then(() => {
          item.mfa = false;
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "MFA",
              text: "MFA resetado com sucesso!",
              variant: "success",
            },
          });
        })
        .catch((err) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erro ao resetar MFA",
              text: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : "Ocorreu um erro ao resetar o MFA.",
              variant: "danger",
            },
          });
        });
    },
  },
};
</script>

<style>
</style>